/**
 * Created by vladislav on 02.06.2022
 */

const ClansTool = {
    fakePlayersAmount: 50,

    addFakePlayers: function () {
        let amount = parseInt(window.prompt("Enter amount", 10));

        if (isNaN(amount)) {
            return;
        }

        let lastFakeIndex = -1;

        cleverapps.userClan.players.forEach(function (player) {
            if (this.isFake(player.id)) {
                const index = parseInt(player.id.replaceAll("_", "")) - 1000;

                if (index > lastFakeIndex) {
                    lastFakeIndex = index;
                }
            }
        }, this);

        amount = Math.min(this.fakePlayersAmount - lastFakeIndex - 1, amount);

        const callback = cleverapps.wait(amount, () => {
            cleverapps.focusManager.closeAllWindows();
            new MyClanWindow();
        });
        for (let i = 0; i < amount; i++) {
            cleverapps.clans.addUserToClan(`__${1000 + lastFakeIndex + 1 + i}`, cleverapps.userClan.id, (data) => {
                cleverapps.loading.hide();

                if (data.error) {
                    cleverapps.notification.create(Messages.get(data.error));
                } else {
                    cleverapps.userClan.update(data);

                    callback();
                }
            }, (err) => {
                cleverapps.loading.hide();
                new NoConnectionWindow();
                console.log(err);
            });
        }
    },

    isFake: function (id) {
        return id.match(/^__10[0-9]{2}$/);
    },

    listFakePlayer: function () {
        return cleverapps.userClan.players.filter(function (player) {
            return this.isFake(player.id);
        }, this);
    },

    sendMessage: function () {
        if (cleverapps.userClan.id === undefined) {
            return {};
        }

        const res = {};

        this.listFakePlayer().forEach((player) => {
            res[player.name || player.id] = () => {
                const messageIds = Object.keys(ClansConfig.MESSAGES).filter((id) => +id !== ClansConfig.MESSAGE_TYPE_ENERGY);

                cleverapps.clanMessages.postMessage({
                    type: PseudoRandom.GET().mathChoose(messageIds),
                    playerId: player.id,
                    playerName: player.name
                });

                cleverapps.focusManager.closeAllWindows();

                new MyClanWindow();
            };
        });

        return res;
    },

    sendRequest: function () {
        if (cleverapps.userClan.id === undefined) {
            return {};
        }

        const res = {};

        this.listFakePlayer().forEach((player) => {
            res[player.name || player.id] = () => {
                cleverapps.clanMessages.postMessage({
                    type: ClansConfig.MESSAGE_TYPE_ENERGY,
                    playerId: player.id,
                    playerName: player.name
                });

                cleverapps.focusManager.closeAllWindows();
                new MyClanWindow();
            };
        });

        return res;
    },

    fillHelp: function () {
        const allPlayers = cleverapps.userClan.players.filter((player) => player.id !== connector.platform.getUserID());

        for (let i = cleverapps.clanMessages.messages.length - 1; i >= 0; --i) {
            const message = cleverapps.clanMessages.messages[i];
            if (ClansConfig.MESSAGES[message.type].help) {
                const messageHelp = message.listHelp();
                const players = allPlayers.filter((player) => messageHelp.every((help) => help.senderId !== player.id));
                const amount = ClansConfig.MESSAGES[message.type].help.times - messageHelp.length;

                if (players.length && amount > 0) {
                    for (let j = 0; j < players.length && j < amount; ++j) {
                        cleverapps.RestClient.post(`${connector.config.multiApiURL}/clans/message/sendhelp`, {
                            messageId: message.messageId,
                            userId: players[j].id,
                            version: cleverapps.config.version
                        });
                    }
                    break;
                }
            }
        }
    }
};
